
// 全局状态类型。暂只支持redux/cone。将值以哪种方式存储/获取，默认以最新全局状态管理方式存储/获取
let lastingStateType = '';

// 全局状态对象
let stateStore = {};

// redux对象
let redux = null;

// 状态监听回调
let callBacks = {};

/**
 * 设置全局状态类型
 * @param {*} isReset 是否重置
 * @returns
 */
const setGlobalStateType = (isReset) => {
  if (isReset) {
    instance.type = '';
    return;
  }
  if (instance.type) return;
  instance.type = lastingStateType;
};

/**
 * 最新全局状态管理相关方法
 */
export const instance = {

  // 全局状态类型，暂只支持redux/cone。可直接使用指针修改该值，该值只决定于下次调用instance的方法所使用的类型，下次调用结束后将会被重置，该值优先级大于setLastingStateType方法设置的值。
  type: '',

  /**
   * 设置持久化全局状态类型
   * @param {String} value 暂只支持redux/cone，调用此方法设置后，后续调用instance的方法将全部以此方法设置的类型为准。
   */
  setLastingStateType(value) {
    lastingStateType = value;
  },

  /**
   * 设置多个键值到全局状态
   * @param {Object} obj 需存储的键值对。当type等于redux时，参考globalRedux的setValues方法参数
   */
  setValues(obj) {
    setGlobalStateType();
    switch (this.type) {
      case 'redux':
        globalRedux.setValues(obj);
        break;
      case 'cone':
        globalState.setValues(obj);
        break;
      default:
        globalState.setValues(obj);
        break;
    }
    setGlobalStateType(true);
  },

  /**
   * 从全局状态中获取多个键值
   * @param {Array} keys 需获取值的键列表。当type等于redux时，参考globalRedux的getValues方法参数
   * @returns 所有需获取的键值对
   */
  getValues(keys) {
    setGlobalStateType();
    let n = {};
    switch (this.type) {
      case 'redux':
        n = globalRedux.getValues(keys);
        break;
      case 'cone':
        n = globalState.getValues(keys);
        break;
      default:
        n = globalState.getValues(keys);
        break;
    }
    setGlobalStateType(true);
    return n;
  },

  /**
   * 重置所有全局状态，调取该方法后，所有存到全局状态内的键值对将被清空，谨慎操作
   * 注：该方法仅支持最新的全局状态重置操作，redux请自行在项目内实现，然后通过setValues调用重置
   */
  reset() {
    stateStore = {};
  },

  /**
   * 获取全局状态内的所有键值对
   * @returns 全局状态内的所有键值对
   */
  getAllValues() {
    setGlobalStateType();
    let n = {};
    switch (this.type) {
      case 'redux':
        n = globalRedux.getAllValues();
        break;
      case 'cone':
        n = globalState.getAllValues();
        break;
      default:
        n = globalState.getAllValues();
        break;
    }
    setGlobalStateType(true);
    return n;
  },

  /**
   * 注册监听函数
   * @param keys 需要监听的字段列表，，redux状态的格式为redux的模块名.字段名
   * @param func 回调函数
   * @returns {{}} 对应字段的回调函数标识，用于取消监听时传入
   */
  monitor(keys, func) {
    const marks = {};
    keys.forEach(k => {
      const timestamp = new Date().getTime() + (Math.random() * 1000).toFixed(0);
      if (!callBacks[k]) {
        callBacks[k] = {};
      }
      callBacks[k][timestamp] = func;
      marks[k] = timestamp;
    });
    return marks;
  },

  unMonitorNew(keys, func) {
    keys.forEach(k => {
      if (callBacks[k] && func) {
        callBacks[k].forEach(t => {
          if (callBacks[k][t] === func ){
            delete callBacks[k][t]
          }
        })
      } else {
        delete callBacks[k];
      }
    });
  },

  /**
   * 取消监听函数
   * @param marks 需要取消的回调函数标识
   */
  unMonitor(marks) {
    Object.keys(callBacks).forEach(k => {
      marks.forEach(m => {
        if (callBacks[k][m]) {
          delete callBacks[k][m];
        }
      });
    });
  },

  /**
   * 事件通知
   * @param obj 需通知的键值对，redux状态键的格式为redux的模块名.字段名
   */
  emit(obj) {
    Object.keys(obj).forEach(k => {
      if (callBacks[k]) {
        for (let m in callBacks[k]) {
          if (callBacks[k].hasOwnProperty(m)) {
            callBacks[k][m](obj);
          }
        }
      }
    });
  }
};

/**
 * 全局状态管理，无state情况
 */
const globalState = {
  // timer: 0,
  setValues({reducer = 'ReduxDefault', state}) {
    if (!state) {
      state = arguments[0];
    }
    const k = reducer.split('.');
    Object.assign(stateStore, { // 这里的state是全局state
      [k[0]]: k[1] ? {
        [k[1]]: state
      }: stateStore[k[0]] ? Object.assign(stateStore[k[0]], state) : state
    });
    // if (this.timer) clearTimeout(this.timer)
    if (Object.prototype.toString.call(state) === '[object Object]') {
      instance.emit(Object.fromEntries(
        Object.entries(state).map(([k ,v]) => [reducer + '.' + k, v])
      ));
    } else {
      instance.emit({
        [reducer]: state
      });
    }
  },
  getValues(keys) {
    const n = {};
    keys.forEach(i => {
      const k = i.split('.');
      if (!n[k[0]]) {
        n[k[0]] = {};
      }

      if (!k[1]) { // 如果只有模块名，没有对应属性名，就返回全部数据
        Object.assign(n[k[0]], stateStore[k[0]]);
      } else {
        Object.assign(n[k[0]], {
          [k[1]]: stateStore[k[0]][k[1]]
        });
      }
    });
    return n;
  },
  getAllValues() {
    return Object.assign({}, stateStore);
  }
}

/**
 * 全局状态管理，redux相关方法
 */
const globalRedux = {
  // timer: 0,
  /**
   * 设置多个键值到redux全局状态
   * @param {string} reducer 对应redux内的某个模块的reducer方法，格式为redux的模块名.方法名
   * @param {object} state 新的需要更新的状态
   * @returns
   */
  setValues({reducer = 'ReduxDefault', state}) {
    if (!redux) {
      console.error('缺少redux对象');
      throw new Error('缺少redux对象');
    }
    if (!state) {
      state = arguments[0];
    }
    const k = reducer.split('.');
    const reduxState = redux.getState()
    Object.assign(reduxState, {
      [k[0]]: k[1] ? {
        [k[1]]: state
      }: reduxState[k[0]] ? Object.assign(reduxState[k[0]], state) : state
    });
    // if (this.timer) clearTimeout(this.timer)
    if (Object.prototype.toString.call(state) === '[object Object]') {
      instance.emit(Object.fromEntries(
        Object.entries(state).map(([k ,v]) => [reducer + '.' + k, v])
      ));
    } else {
      instance.emit({
        [reducer]: state
      });
    }
    // redux.dispatch[k[0]][k[1]](state);
  },

  /**
   * 从redux全局状态中获取多个键值
   * @param {*} keys 需获取值的键列表，键的格式为redux的模块名.字段名
   * @returns 所有需获取的键值对
   */
  getValues(keys) {
    if (!redux) {
      console.error('缺少redux对象');
      throw new Error('缺少redux对象');
    }
    const n = {};
    const reduxState = redux.getState();
    keys.forEach(i => {
      const k = i.split('.');
      if (!n[k[0]]) {
        n[k[0]] = {};
      }

      if (!k[1]) { // 如果只有模块名，没有对应属性名，就返回全部数据
        Object.assign(n[k[0]], reduxState[k[0]]);
      } else {
        Object.assign(n[k[0]], {
          [k[1]]: reduxState[k[0]][k[1]]
        });
      }
    });
    return n;
  },

  /**
   * 获取redux全局状态内的所有键值对
   * @returns redux全局状态内的所有键值对
   */
  getAllValues() {
    if (!redux) {
      console.error('缺少redux对象');
      throw new Error('缺少redux对象');
    }
    return redux.getState();
  }
};

/**
 * 初始化
 * @param {*} r redux实例
 */
export const init = (r) => {
  if (r) {
    redux = r;
    instance.setLastingStateType('redux');
  }
  // redux && Object.assign(state, redux.getState()); // 初始化的时候同步redux 到 state
  // if (!window.getGlobalStateInstance) {
  //   window['getGlobalStateInstance'] = () => {
  //     return {
  //       version: '0.0.3',
  //       instance: instance,
  //     }
  //   };
  // }
  return instance;
};

/**
 * redux监听函数
 * @param getState
 * @returns {function(*): function(*=)}
 */
export const reduxMonitor = ({ getState }) => {
  return next => action => {
    const returnValue = next(action);

    // 发送状态监听通知start
    const moduleName = action.type.split('/')[0];
    const ns = {};
    for (let k in action.payload) {
      if (action.payload.hasOwnProperty(k)) {
        ns[moduleName + '.' + k] = action.payload[k];
      }
    }
    // redux && Object.assign(state, redux.getState()); // 同步redux 到 state
    instance.emit(ns);
    // 发送状态监听通知end

    return returnValue
  }
};

export const version = '0.0.3';